export const DEFAULT_TOP_SLOT_NAME = "top_leaderboard";

export const FAN_TAKEOVER_SIZES: {
  [key in "DESKTOP" | "MOBILE" | "MAX"]: [number, number];
} = {
  DESKTOP: [3, 3],
  MAX: [3, 3],
  MOBILE: [2, 2],
};

/**
 * Timeout that delays unblocking the video to give time for the tentpole custom creative to activate it.
 * When the tentpole custom creative is not used, after this timeout resolves the video will be unblocked anyway.
 */
export const TENTPOLE_ACTIVATOR_TIMEOUT = 250; // ms
